import { render, staticRenderFns } from "./codification-seiasa.vue?vue&type=template&id=ef5b4256"
import script from "./codification-seiasa.vue?vue&type=script&lang=js"
export * from "./codification-seiasa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports